import axios from "axios";
import { API_ENDPOINT } from "../constants/env";

// let API_ENDPOINT= process.env.REACT_APP_API_ENDPOINT;
// if (process.env.REACT_APP_ENV === 'qa') {
//   API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT_QA;
// } else if (process.env.REACT_APP_ENV === 'prod') {

// } else {
//   API_ENDPOINT 
// }

const api = axios.create({
  baseURL: API_ENDPOINT,
});
console.log(API_ENDPOINT)
export default api;